import { CourseDef } from '../../../../types';
import L2084310 from './2084310';
import L2079354 from './2079354';
import L2079355 from './2079355';
import L2079356 from './2079356';
import L2079357 from './2079357';
import L2079358 from './2079358';
import L2079359 from './2079359';
import L2079360 from './2079360';
// import L5234471 from './5234471';
import L5234472 from './5234472';

export const introducaoTecnica: CourseDef = {
  courseTitle: 'INTRODUÇÃO TÉCNICA',
  lessons: [
    L2084310,
    L2079354,
    L2079355,
    L2079356,
    L2079357,
    L2079358,
    L2079359,
    L2079360,
    // L5234471,
    L5234472,
  ],
};

